import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";

import IndexadoresModule from './modules/indexadores.js' 
import DatasModule from './modules/datas.js'
import SystemJwtTokenModule from './modules/systemJwtToken.js'
import CarteirasModule from './modules/carteira.js'
import SessaoModule from './modules/sessao.js'


Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        systemToken: SystemJwtTokenModule,
        indexadores: IndexadoresModule,
        datas: DatasModule,
        carteiras: CarteirasModule,
        sessao: SessaoModule
    },
    plugins: [
        createPersistedState({
            reducer: (persistedState) => {
                const stateFilter = JSON.parse(JSON.stringify(persistedState)); // deep clone
                ['offsidebarOpen', 'asideToggled', 'horizontal'] // states which we don't want to persist.
                    .forEach((item) => {
                        try {
                            delete stateFilter.setting[item]
                        } catch (ex) {}
                    })
                return stateFilter
            }
        })
    ]
})